import axios from "axios";
const getEdgeLocation = (token) => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl}/v3/content/champions/mobii/regions`,
      headers: {  
        'authorization': token, 
        'x-api-key': window?.xApiKey
      }
    };
    
  return axios.request(config)
    .then((response) => {
      let data = response?.data?.uris;
      let pings = [];
      for (let i = 0; i < data?.length; i++) {
        pings.push(pingRegion(data[i]));
      }

      return Promise.all(pings).then((pingvalues) => {
        let sortedPings = pingvalues.sort((a, b) => a.ping - b.ping);
        console.log('%c AVAILABLE EDGE LOCATIONS ', 'background: #bdff69; color: #000',sortedPings);
        let newegionId = sortedPings?.[0]?.regionId
        let getRegionId = newegionId || null;
        sessionStorage.setItem('edgeRegionId',getRegionId);
        let url= sortedPings?.[0]?.uri;
       return url?.slice(0,-1) || null;
      })
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
}

const pingRegion = async (region) => {
  let regionUri = region?.uris?.find((x) => x.type === 3);
  if (!regionUri) return null;
  let pings = [];
  let pingCount = 5;
  let pingsToTake = 3;
  for (let i = 0; i < pingCount; i++) {
    let ping = performance.now();
    await fetch(`${regionUri?.uri}api/regionidentifier/identifyregion`, {
      mode: "no-cors",
    })
    ping = performance.now() - ping;
    pings.push(ping);
  }
  let topPings = pings?.slice(-pingsToTake);
  return {
    regionId: region?.regionId,
    ping: topPings?.reduce((a, b) => a + b, 0) / pingsToTake,
    uri: regionUri?.uri
  };
};

export { getEdgeLocation }